export default {
  chat: 'Чат',
  message: 'Сообщение',
  sendMessage: 'Отправить сообщение',
  noMessagesYet: 'Здесь пока ничего нет...',
};
